import "react-datepicker/dist/react-datepicker.css";

import TransferService from "../../services/TransferBetweenWarehouses";
import { useEffect, useState } from "react";
import { Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import withLoader from "../../components/layouts/WithLoader";

const DemandeTransfertInformation = ({startLoading,stopLoading}) => {
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();

  const [transfertProducts, setTransfertProducts] = useState([]);

  useEffect(() => {
    startLoading();
    TransferService.getWarehouseTransfertProductsInformations(
      sessionStorage.getItem("refTransfert")
    )
      .then((response) => {
        if (response.data.success) {
          setTransfertProducts(response.data.success);
        } else {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : il ya un erreur  ");
        }
      })
      .catch((error) => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : ",error);
      }).finally(() => {
        stopLoading();
      });
  }, []);

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  const columns = [
    {
      dataField: "name",
      text: "Libellé",
      headerAlign: "center",
    },
    {
      dataField: "productCode",
      text: "Code Article",
      headerAlign: "center",
    },

    {
      dataField: "quantity",
      text: "Qte",
      align: "center",
      headerAlign: "center",
    },
  ];
  function handleTableChange({ transfertProducts }) {
    return transfertProducts;
  }

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid"></div>
      </section>
      <div className="content ">
        <div className="container-fluid">
          <div className="card">
            <div className="card-header">
              <h3 className="card-title">
                Le transfert : {sessionStorage.getItem("refTransfert")}
              </h3>
            </div>
            <div className="card-body">
              {transfertProducts.length>0 && (
                <ToolkitProvider
                  keyField="idProduct"
                  data={transfertProducts}
                  columns={columns}
                  onTableChange={handleTableChange}
                >
                  {(props) => (
                    <div className="row">
                      <BootstrapTable
                        {...props.baseProps}
                        striped
                        hover
                        condensed
                      />
                    </div>
                  )}
                </ToolkitProvider>
              )}
            </div>
          </div>
        </div>
      </div>

      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
    </div>
  );
};
export default withLoader(DemandeTransfertInformation);
